import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/store';
import { asyncFetchSessionUserScores } from 'store/reducers/users/thunks';
import './HistoryPage.scss';
import ScoreHistory from 'layouts/scoreHistory';

function HistoryPage(): React.ReactElement {
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(asyncFetchSessionUserScores());
    }, [dispatch]);

    const { sessionUserScores } = useAppSelector(state => state.usersStore);

    return (
        <div className="history-page">
            <ScoreHistory userScores={sessionUserScores} />
        </div>
    );
}

export default React.memo(HistoryPage);
